import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export function useProfileTestCards() {
  const { data } = useSelfcare(false);
  return { data: data?.test_cards };
}
